var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:_vm.$style.header},[_c('div',{class:_vm.$style.wrapper},[_c('router-link',{class:_vm.$style.logo,attrs:{"tag":"img","to":"/","src":_vm.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }